import React from 'react';
import PropTypes from 'prop-types';
import * as Actions from 'actions';
import { connect } from 'react-redux';

const mapStateToProps = ({ mapCreator, socket }) => ({ mapCreator, socket });

const mapCreatorConnect = Component => connect(mapStateToProps, Actions)(Component);

export default mapCreatorConnect;



// WEBPACK FOOTER //
// ./src/browser/higher-order-components/map-creator-connect.js